module.exports = __webpack_public_path__ + "img/fe748bd.jpg";